import { useEffect, useState } from 'react';

const GRAVATAR_URL = 'https://www.gravatar.com/avatar/';

export const useGravatar = (emailHash?: string) => {
    const [imgSrc, setImgSrc] = useState<string | undefined>();
    useEffect(() => {
        setImgSrc(emailHash ? `${GRAVATAR_URL}${emailHash}?s=50&r=pg&d=404` : undefined);
    }, [emailHash]);

    return { imgSrc };
};
